'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _MutualFundsETFs = require('./MutualFundsETFs.css');

var _MutualFundsETFs2 = _interopRequireDefault(_MutualFundsETFs);

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MutualFundsETFs = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.shareClass.result,
    loading: state.shareClass.loading,
    loaded: state.shareClass.loaded,
    error: state.shareClass.error
  };
}, searchActions), _dec2 = (0, _reduxAsyncConnect.asyncConnect)([{
  // need otherwise cient navigate is blocked until the page is loaded
  deferred: true,
  promise: function promise(_ref) {
    var params = _ref.params,
        _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    return dispatch(searchActions.shareClassDetails(params.fundId, params.investmentVehicleId));
  }
}]), _dec3 = (0, _reactCssModules2.default)(_MutualFundsETFs2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MutualFundsETFs, _Component);

  function MutualFundsETFs(props) {
    (0, _classCallCheck3.default)(this, MutualFundsETFs);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MutualFundsETFs.__proto__ || (0, _getPrototypeOf2.default)(MutualFundsETFs)).call(this, props));

    _this.state = {
      title: 'Mutual funds and ETFs',
      description: 'See how mutual funds popular in employee retirement plans are rated on environmental and social sustainability issues.',
      url: _config2.default.domain + _config2.default.routes.mutualFundsETFs
    };
    return _this;
  }

  (0, _createClass3.default)(MutualFundsETFs, [{
    key: 'render',
    value: function render() {
      if (!this.props.result) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: false
          })
        );
      }
      var _props$result = this.props.result,
          shareClass = _props$result.shareClass,
          fund = _props$result.fund;


      var fff = require('../../../static/images/iyv-thumbs/fff-thumbnail.jpg');
      var dff = require('../../../static/images/iyv-thumbs/dff-thumbnail.jpg');
      var gef = require('../../../static/images/iyv-thumbs/gef-thumbnail.jpg');
      var gff = require('../../../static/images/iyv-thumbs/gff-thumbnail.jpg');
      var pff = require('../../../static/images/iyv-thumbs/pff-thumbnail.jpg');
      var wff = require('../../../static/images/iyv-thumbs/wff-thumbnail.jpg');
      var tff = require('../../../static/images/iyv-thumbs/tff-thumbnail.jpg');
      var goodBadImg = require('../../../static/images/good-and-bad.jpg');

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _container2.default.helmet(this.state.title, this.state.description, this.state.url),
        _react2.default.createElement(
          'div',
          { styleName: 'search-box' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'div',
              { styleName: 'search-box-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'search-box-search' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'search-box-label' },
                  _react2.default.createElement(
                    'h1',
                    null,
                    'Check if your mutual funds and ETFs are climate safe'
                  )
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(_components.AutocompleteSearch, null),
                _react2.default.createElement(
                  'div',
                  { styleName: 'search-box-link' },
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.routes.clean,
                      title: 'Full list'
                    },
                    'Full list',
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'search-box-img' },
                _react2.default.createElement('img', {
                  src: goodBadImg,
                  alt: 'Search mutual funds'
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          shareClass && fund ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.IyvScorecard, { fund: fund, shareClass: shareClass })
          ) : null
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null)
      );
    }
  }]);
  return MutualFundsETFs;
}(_react.Component), _class2.propTypes = {
  loading: _react.PropTypes.bool,
  loaded: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.object
}, _class2.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp)) || _class) || _class) || _class);
exports.default = MutualFundsETFs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MutualFundsETFs/MutualFundsETFs.js
// module id = 1492
// module chunks = 0